import { render, staticRenderFns } from "./comp-room.vue?vue&type=template&id=0b75088b&scoped=true&"
import script from "./comp-room.vue?vue&type=script&lang=js&"
export * from "./comp-room.vue?vue&type=script&lang=js&"
import style0 from "./comp-room.vue?vue&type=style&index=0&id=0b75088b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b75088b",
  null
  
)

/* custom blocks */
import block0 from "./comp-room.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b75088b')) {
      api.createRecord('0b75088b', component.options)
    } else {
      api.reload('0b75088b', component.options)
    }
    module.hot.accept("./comp-room.vue?vue&type=template&id=0b75088b&scoped=true&", function () {
      api.rerender('0b75088b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trial/videoTrial/demo/components/comp-room.vue"
export default component.exports